import styled from 'styled-components';
import { FilterDescription } from 'src/components/filters/types';
import { FilterOptionsDiscriminator } from 'src/components/filters/FilterOptionsDiscriminator';
import { useTranslate } from 'react-t7e';
import { dirRTL } from 'src/styles/theme';

export const FiltersBarHeader = styled.div`
  position: relative;
  display: block;
  color: ${({ theme }) => theme.text.palette.accent};
  font-weight: 300;
  font-size: 12px;
  line-height: 175%;

  letter-spacing: 0.04em;
  text-transform: uppercase;
  direction: ltr;
  ${dirRTL} {
    text-align: right;
  }
`;
export const FilterLabel = styled(FiltersBarHeader)`
  color: ${({ theme }) => theme.text.palette.primary};
`;
export const FilterBlockContainer = styled.div`
  display: grid;
  grid-template-areas: 'header' 'options';
  grid-gap: 8px;
  margin-top: 14px;
  margin-bottom: 30px;
`;

export const FilterBlock = ({ filter }: { filter: FilterDescription }) => {
  const { _ } = useTranslate();
  return (
    <FilterBlockContainer>
      <FilterLabel>{_(filter.title)}</FilterLabel>
      <FilterOptionsDiscriminator filter={filter} />
    </FilterBlockContainer>
  );
};
